export const SET_PUSHER_INSTANCE = 'SET_PUSHER_INSTANCE'
